import HATVDashboard from "../components/HATV/HATVDashboard/HATVDashboard";

interface Props {
  showHatvChatbot?: boolean
}

const HATVPage: React.FC<Props> = ({ showHatvChatbot }) => {
  return <HATVDashboard showHatvChatbot={showHatvChatbot} />;
}

export default HATVPage;
